import React from 'react'
import styled, { keyframes } from 'styled-components'
import { useDemo } from '../DemoProvider'

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(59, 130, 246, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);
  }
`

const Banner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 40px;
  background: linear-gradient(
    90deg,
    rgba(59, 130, 246, 0.1) 0%,
    rgba(59, 130, 246, 0.2) 50%,
    rgba(59, 130, 246, 0.1) 100%
  );
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  z-index: 1100;
  border-bottom: 1px solid rgba(59, 130, 246, 0.2);
`

const DemoLabel = styled.div`
  background: rgba(59, 130, 246, 0.2);
  color: var(--color-primary);
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  animation: ${pulse} 2s infinite;
`

const Message = styled.p`
  color: var(--color-text);
  font-size: 0.875rem;
`

const Button = styled.button`
  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 0.5rem;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-1px);
  }
`

const DemoBanner = () => {
  const { exitDemoMode } = useDemo()

  return (
    <Banner>
      <DemoLabel>Demo Mode</DemoLabel>
      <Message>
        You are currently in Demo Mode. All actions are simulated.
      </Message>
      <Button onClick={exitDemoMode}>
        Exit Demo Mode
      </Button>
    </Banner>
  )
}

export default DemoBanner
